import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Navigation } from 'lucide-react';
import { SITE } from '../data/site';
import { Testimonials } from '../components/home/GalleryTestimonials';

export default function ContactUs() {
  useEffect(() => {
    document.title = 'Contact Us - Phoenix Roofing & Chimney NJ';
  }, []);
  return (
    <div data-testid="contact-page">
      <section className="py-20 bg-secondary">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="section-title">Contact Us</h1>
          <p className="mt-5 text-lg text-foreground/85">
            Choose <strong>Phoenix Roofing & Chimney</strong> for reliable, affordable, and expert roofing services in New Jersey.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <a href={SITE.phoneHref} className="bg-background shadow-card p-8 flex flex-col items-center hover:-translate-y-1 transition-transform duration-300" data-testid="contact-phone-card">
              <Phone className="w-8 h-8 text-primary" />
              <h3 className="font-heading font-semibold text-lg mt-4">Call Edison directly</h3>
              <p className="mt-2 text-primary font-display font-bold text-xl">{SITE.phone}</p>
            </a>
            <a href={`mailto:${SITE.email}`} className="bg-background shadow-card p-8 flex flex-col items-center hover:-translate-y-1 transition-transform duration-300" data-testid="contact-email-card">
              <Mail className="w-8 h-8 text-primary" />
              <h3 className="font-heading font-semibold text-lg mt-4">Email Us</h3>
              <p className="mt-2 text-foreground/85 break-all">{SITE.email}</p>
            </a>
            <a href={SITE.addressMapHref} target="_blank" rel="noreferrer" className="bg-background shadow-card p-8 flex flex-col items-center hover:-translate-y-1 transition-transform duration-300" data-testid="contact-area-card">
              <Navigation className="w-8 h-8 text-primary" />
              <h3 className="font-heading font-semibold text-lg mt-4">Visit Us</h3>
              <p className="mt-2 text-foreground/85">{SITE.address}</p>
            </a>
          </div>
          <Link to="/free-estimate" className="btn-cta mt-12" data-testid="contact-estimate-btn">
            Request a free in-house Estimate
          </Link>
          <p className="mt-4 font-heading text-foreground/85">Free Inspections – Same Day Service</p>
        </div>
      </section>
      <Testimonials />
    </div>
  );
}
